import { useMachine } from "@xstate/react";
import React from "react";
import Step from "../form-layout/Step";
import stepperMachine from "./stepperMachine";
import CareerBreak from "./steps/CareerBreak";
import Leave from "./steps/Leave";
import Mutualiteit from "./steps/Mutualiteit";
import PerformedHours from "./steps/PerformedHours";
import Quarter from "./steps/Quarter";
import Result from "./steps/Result";
import Situation from "./steps/Situation";
import Unemployed from "./steps/Unemployed";
import Welcome from "./steps/Welcome";


type State = {
  context: {
    stack: any | {};
    memory: any | [];
  };
  [key: string]: any;
};

export const StateContext = React.createContext<State | undefined>(undefined);
export const SendContext = React.createContext<any | undefined>(undefined);

const BepaalStatuut = () => {
  const [state, send] = useMachine(stepperMachine);

  // console.log(state.value);
  // console.log(state);
  return (
    <div>
      <StateContext.Provider value={state}>
        <SendContext.Provider value={send}>
          <Step name="welcome">
            <Welcome />
          </Step>
          <Step name="quarter">
            <Quarter />
          </Step>
          <Step name="situation">
            <Situation />
          </Step>
          <Step name="careerBreak">
            <CareerBreak />
          </Step>
          <Step name="performedHours">
            <PerformedHours />
          </Step>
          <Step name="leave">
            <Leave />
          </Step>
          <Step name="mutualiteit">
            <Mutualiteit />
          </Step>
          <Step name="unemployed">
            <Unemployed />
          </Step>
          <Step name="secondaryActivityTrue">
            <Result result="secondaryTrue" />
          </Step>
          <Step name="secondaryActivityFalse">
            <Result result="secondaryFalse" />
          </Step>
          <Step name="secondaryActivityUndecided">
            <Result result="secondaryUndecided" />
          </Step>
        </SendContext.Provider>
      </StateContext.Provider>
    </div>
  );
};

export default BepaalStatuut;
